import * as React from "react";
import { Checkbox as AntDCheckbox } from "antd";

class Checkbox extends React.Component<any, any> {
  render() {
    return (
      <div
        className={this.props.className}
        data-automation-id={this.props.dataAutomationID}
      >
        <AntDCheckbox {...this.props}></AntDCheckbox>
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./client/modules/core/Checkbox/index.tsx